import dashboardComponent from './dashboard.component';

const dashboardModule = angular.module('dashboard', [
])
  .component('dashboard', dashboardComponent)
  .name;

export default dashboardModule;
